var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-stepper',{attrs:{"title":_vm.$lang.stepper_ProfileSignup,"steps":_vm.steps,"stepIndex":_vm.stepIndex},on:{"update:stepIndex":function($event){_vm.stepIndex=$event},"update:step-index":function($event){_vm.stepIndex=$event}},scopedSlots:_vm._u([{key:"step-complete",fn:function(){return undefined},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }